// extracted by extract-css-chunks-webpack-plugin
module.exports = {"image":"img__image--3g3zE"};